export default "__VITE_ASSET__DEFwtOII__";